import { render, staticRenderFns } from "./V2CurrencyBooksModal.vue?vue&type=template&id=186f505b&scoped=true&"
import script from "./V2CurrencyBooksModal.vue?vue&type=script&lang=js&"
export * from "./V2CurrencyBooksModal.vue?vue&type=script&lang=js&"
import style0 from "./V2CurrencyBooksModal.vue?vue&type=style&index=0&id=186f505b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186f505b",
  null
  
)

export default component.exports